import React from "react";
import { Pagination, PaginationItem, PaginationLink } from "reactstrap";

export const PaginationControls = (props) => {
    // Shoot tables pass the page as `shoots`, job tables as `jobs`; both carry pageCount. Reading only
    // `shoots` left every job table with no page numbers and a Next button that ran past the end.
    const page = props.shoots || props.jobs;

    const handlePageClick = async (e, index) => {
        e.preventDefault();
        props.setCurrentPage(index);
    };

    return (
        <Pagination size="lg">
            <PaginationItem>
                <PaginationLink
                    first
                    href="#"
                    onClick={e => handlePageClick(e, 0)}
                />
            </PaginationItem>
            <PaginationItem disabled={props.currentPage === 0}>
                <PaginationLink
                    href="#"
                    previous
                    onClick={e => handlePageClick(e, props.currentPage - 1)}

                />
            </PaginationItem>
            {page && [...Array(page.pageCount)].map((_, i) => (
                <PaginationItem active={i === props.currentPage} key={i}>
                    <PaginationLink onClick={e => handlePageClick(e, i)} href="#">
                        {i + 1}
                    </PaginationLink>
                </PaginationItem>
            ))}
            <PaginationItem disabled={!page || props.currentPage >= page.pageCount - 1}>
                <PaginationLink
                    href="#"
                    next
                    onClick={e => handlePageClick(e, props.currentPage + 1)}
                />
            </PaginationItem>
            <PaginationItem>
                <PaginationLink
                    href="#"
                    last
                    onClick={e => handlePageClick(e, props.shoots.pageCount - 1)}
                />
            </PaginationItem>
        </Pagination>
    );
};

export default PaginationControls;
